import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Login|SSO';

const sharedProps: Pick<LocDef, 'portal' | 'shared' | 'htmlAllowed'> = {
	portal: 'CP',
	shared: false,
	htmlAllowed: false,
};

export type SsoLocNames = 'CPLoginImpersonationIngressPageTitle' | 'CPLoginSSOPageTitle';

export const cpSsoLocs: LocDefs<SsoLocNames> = {
	CPLoginImpersonationIngressPageTitle: {
		defaultValue: 'Candidate Impersonation',
		description: 'Page title for the SSO page',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccess,
		legacyName: 'CandidateAccess/Impersonation.Ingress.Title.PageTitle',
		...sharedProps,
	},
	CPLoginSSOPageTitle: {
		defaultValue: 'SSO',
		description: 'Page title for the SSO page',
		displayPath: `${dpRoot}|Page Title`,
		displayType: 'Title',
		feature: HubFeature.CandidateAccessIntegrationIngress,
		legacyName: 'CandidateAccess.Integration.Ingress/Login.SSO.Title.PageTitle',
		...sharedProps,
	},
};

export const LOC_KEYS = MapLocKeys<SsoLocNames>(cpSsoLocs);
export type CPLoginSsoType = LocMap<SsoLocNames>;
